import { useProjectsFilterFormik } from "./use-projects-filters-formik"
import { useHistory } from "react-router-dom"
import { useQueryParams } from "hooks/app-router"
import { useState, useEffect } from "react"

export function useProjectsFiltersQueryParams() {
  const formik = useProjectsFilterFormik()
  const history = useHistory()

  const params = useQueryParams<{
    name?: string
    state: "active" | "archived" | "all"
    billable?: "yes" | "no" | undefined
    groups?: string
    users?: string
    clients?: string
  }>()

  const [nameFilter, setNameFilter] = useState<string | undefined>(undefined)
  const [stateFilter, setStateFilter] = useState<
    "active" | "archived" | "all"
  >("active")
  const [billableFilter, setBillableFilter] = useState<
    "yes" | "no" | undefined
  >(undefined)
  const [clientHashIds, setClientHashIds] = useState<string[] | undefined>([])
  const [membersGroupHashIds, setMembersGroupHashIds] = useState<
    string[] | undefined
  >([])
  const [usersAccountHashIds, setUsersAccountHashIds] = useState<
    string[] | undefined
  >([])

  function update(values: typeof formik.values) {
    const { name, billable, state, clients, groups, users } = values

    const params = new URLSearchParams()
    name && params.append("name", name)
    state && params.append("state", state as "active" | "archived" | "all")
    billable !== undefined && params.append("billable", billable ? "yes" : "no")
    groups &&
      groups?.length > 0 &&
      params.append("groups", JSON.stringify(groups))
    users && users?.length > 0 && params.append("users", JSON.stringify(users))
    clients &&
      clients?.length > 0 &&
      params.append("clients", JSON.stringify(clients))

    history.push(`?${params}`)
  }

  useEffect(() => {
    setNameFilter(params.name)
    setStateFilter(params.state)
    setBillableFilter(params.billable)
    setClientHashIds(params.clients ? JSON.parse(params.clients) : [])
    setMembersGroupHashIds(params.groups ? JSON.parse(params.groups) : [])
    setUsersAccountHashIds(params.users ? JSON.parse(params.users) : [])
  }, [history.location.search])

  return {
    nameFilter,
    stateFilter,
    billableFilter,
    clientHashIds,
    usersAccountHashIds,
    membersGroupHashIds,
    update,
  }
}
